import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {

  public wwwUrl: string;
  public adminUrl: string;
  public rateTableUrl: string;
  public apiKey: string = 'bcef7b5f-31a4-48b3-8bcc-9012f6a4330f';
  public fruApiUrl: string; // Laravel API
  public fruAPI: string; // CodeIgniter API

  initAppConfig() {
    let hostname: string = window.location.hostname;
    this.wwwUrl = `https://${hostname}`;

    if (/www.freerateupdate.com/.test(hostname)) {
      this.adminUrl = this.wwwUrl.replace('www.freerateupdate.com', 'admin.freerateupdate.com');
      this.rateTableUrl = this.wwwUrl.replace('www.freerateupdate.com', 'ratetables.freerateupdate.com');
      this.fruAPI = this.wwwUrl.replace('www.freerateupdate.com', 'api.freerateupdate.com');

      if (/-www\./.test(hostname)) {
        this.fruApiUrl = this.wwwUrl.replace('www.freerateupdate.com', 'fru-api.freerateupdate.com:8002');
      } else {
        this.fruApiUrl = this.wwwUrl.replace('www.freerateupdate.com', 'fru-api.freerateupdate.com');
      }
    } else if (/leads.freerateupdate.com/.test(hostname)) {
      this.adminUrl = this.wwwUrl.replace('www.freerateupdate.com', 'admin.freerateupdate.com');
      this.rateTableUrl = this.wwwUrl.replace('www.freerateupdate.com', 'ratetables.freerateupdate.com');
      this.fruAPI = this.wwwUrl.replace('leads.freerateupdate.com', 'api.freerateupdate.com');

      if (/-leads.freerateupdate.com/.test(hostname)) {
        this.fruApiUrl = this.wwwUrl.replace('leads.freerateupdate.com', 'fru-api.freerateupdate.com:8002');
      } else {
        this.fruApiUrl = this.wwwUrl.replace('leads.freerateupdate.com', 'fru-api.freerateupdate.com');
      }
    } else {
      // See if we're in prod
      if (/^www/.test(hostname)) {
        this.adminUrl = 'https://admin.freerateupdate.com';
        this.rateTableUrl = 'https://ratetables.freerateupdate.com';
        this.fruApiUrl = 'https://fru-api.freerateupdate.com';
        this.fruAPI = 'https://api.freerateupdate.com';
      } else {
        // Get subdomain and make dev urls
        let allSplitUp = hostname.split('.');
        let subdomain = allSplitUp[0];
        
        if (hostname.includes('pathtohome')) {
          let p2hSubdomain = subdomain.substring(0, subdomain.length - 4);
          this.adminUrl = `https://${p2hSubdomain}-admin.freerateupdate.com`;
          this.rateTableUrl = `https://${p2hSubdomain}-ratetables.freerateupdate.com`;
          this.fruApiUrl = `https://${p2hSubdomain}-fru-api.freerateupdate.com:8002`;
          this.fruAPI = `https://${p2hSubdomain}-api.freerateupdate.com`;
        } else {
          this.adminUrl = `https://${subdomain}-admin.freerateupdate.com`;
          this.rateTableUrl = `https://${subdomain}-ratetables.freerateupdate.com`;
          this.fruApiUrl = `https://${subdomain}-fru-api.freerateupdate.com:8002`;
          this.fruAPI = `https://${subdomain}-api.freerateupdate.com`;
        }

        
      }
    }
  }

  constructor() {
    this.initAppConfig();
  }
}
